import { BackgroundControlWithFiles } from '@ansvar-sakerhet/api-client';

export const findLatestReport = (
  reportFiles: BackgroundControlWithFiles['reportFiles']
) => {
  return reportFiles.sort((a, b) => {
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
  })[0];
};
